/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const clinicAnalyticsEventTypeSv = {
  ACCOUNTING_CODES_SYNCED: "Bokföringskoder synkroniserade",
  ACCOUNTING_CODE_ADDED: "Bokföringskod tillagd",
  ACCOUNTING_CODE_DELETED: "Bokföringskod raderad",
  ACCOUNTING_CODE_UPDATED: "Bokföringskod uppdaterad",
  ADDRESS_ADDED: "Adress tillagd",
  ADDRESS_DELETED: "Adress raderad",
  CHARGE_PAID: "Avgift betald",
  CLINIC_DELETED: "Klinik raderad",
  CLINIC_DELETION_STARTED: "Klinikradering påbörjad",
  CLINIC_FEES_UPDATED: "Klinikavgifter uppdaterade",
  CLINIC_REGISTERED: "Klinik registrerad",
  CLINIC_UPDATED: "Klinik uppdaterad",
  CREDIT_CARD_UPDATED: "Kreditkort uppdaterat",
  EMAIL_ADDED: "E-post tillagd",
  EMAIL_CONFIRMATION_RESENT: "E-postbekräftelse skickad igen",
  EMAIL_CONFIRMED: "E-post bekräftad",
  EMAIL_DELETED: "E-post raderad",
  EMPLOYEE_ADDED: "Anställd tillagd",
  EMPLOYEE_DELETED: "Anställd raderad",
  EMPLOYMENT_REQUEST_ADDED: "Anställningsförfrågan tillagd",
  EMPLOYMENT_REQUEST_DELETED: "Anställningsförfrågan raderad",
  EMPLOYMENT_REQUEST_REJECTED: "Anställningsförfrågan avvisad",
  FORTNOX_DISABLED: "Fortnox inaktiverad",
  FORTNOX_ENABLED: "Fortnox aktiverad",
  FREE_TEXT_MEDICAL_RECORD_ADDED: "Fritextjournal tillagd",
  FREE_TEXT_MEDICAL_RECORD_DELETED: "Fritextjournal raderad",
  GIRO_ACCOUNTS_UPDATED: "Girokonton uppdaterade",
  INVENTORY_CATEGORY_ADDED: "Inventariekategori tillagd",
  INVENTORY_CATEGORY_DELETED: "Inventariekategori raderad",
  INVENTORY_CATEGORY_UPDATED: "Inventariekategori uppdaterad",
  INVENTORY_ITEMS_USED: "Inventarieartiklar använda",
  INVENTORY_ITEM_ADDED: "Inventarieartikel tillagd",
  INVENTORY_ITEM_DELETED: "Inventarieartikel raderad",
  INVENTORY_ITEM_STOCK_ADDED: "Inventarielager tillagt",
  INVENTORY_ITEM_STOCK_COUNTING_ADDED: "Inventarielagerinventering tillagd",
  INVENTORY_ITEM_STOCK_COUNTING_DELETED: "Inventarielagerinventering raderad",
  INVENTORY_ITEM_STOCK_DELETED: "Inventarielager raderat",
  INVENTORY_ITEM_STOCK_UPDATED: "Inventarielager uppdaterat",
  INVENTORY_ITEM_UPDATED: "Inventarieartikel uppdaterad",
  INVENTORY_ITEM_USAGE_ADDED: "Inventarieanvändning tillagd",
  INVENTORY_ITEM_USAGE_DELETED: "Inventarieanvändning raderad",
  INVENTORY_ITEM_USAGE_UPDATED: "Inventarieanvändning uppdaterad",
  INVENTORY_UPDATED: "Inventarie uppdaterad",
  INVOICE_ADDED: "Faktura tillagd",
  INVOICE_BILLED: "Faktura fakturerad",
  INVOICE_CANCELLED: "Faktura annullerad",
  INVOICE_DELETED: "Faktura raderad",
  INVOICE_PAID: "Faktura betald",
  LOGO_ADDED: "Logotyp tillagd",
  LOGO_DELETED: "Logotyp raderad",
  MEDICAL_RECORD_CREATED: "Journal skapad",
  MEDICAL_RECORD_MAIL_SENT: "Journal skickad via e-post",
  MEDICAL_RECORD_SIGNED: "Journal signerad",
  PAYMENT_ADDED: "Betalning tillagd",
  PAYMENT_METHOD_ADDED: "Betalningsmetod tillagd",
  PAYMENT_METHOD_DELETED: "Betalningsmetod raderad",
  PAYMENT_METHOD_UPDATED: "Betalningsmetod uppdaterad",
  PAYMENT_REMINDER_SENT: "Betalningspåminnelse skickad",
  PAYMENT_SYNCED: "Betalning synkroniserad",
  PAYMENT_WITHDRAWN: "Betalning återkallad",
  PET_ADDED: "Djur tillagt",
  PET_ARCHIVED: "Djur arkiverat",
  PET_OWNER_ADDED: "Djurs ägare tillagd",
  PET_OWNER_ARCHIVED: "Djurs ägare arkiverad",
  PET_OWNER_UPDATED: "Djurs ägare uppdaterad",
  PET_TRANSFERRED: "Djur överfört",
  PET_TRANSFER_STARTED: "Djuroverföring påbörjad",
  PET_UPDATED: "Djur uppdaterat",
  PHARMACY_ADDED: "Apotek tillagt",
  PHARMACY_DELETED: "Apotek raderat",
  PHONE_ADDED: "Telefon tillagd",
  PHONE_CONFIRMATION_RESENT: "Telefonbekräftelse skickad igen",
  PHONE_CONFIRMED: "Telefon bekräftad",
  PHONE_DELETED: "Telefon raderad",
  PRESCRIPTION_CREATED: "Recept skapat",
  PRIMARY_ADDRESS_CHANGED: "Primäradress ändrad",
  PRIMARY_EMAIL_CHANGED: "Primär e-post ändrad",
  PRIMARY_PHONE_CHANGED: "Primärtelefon ändrad",
  RESERVATION_ADDED: "Bokning tillagd",
  RESERVATION_DELETED: "Bokning raderad",
  RESERVATION_TYPE_ADDED: "Bokningstyp tillagd",
  RESERVATION_TYPE_DELETED: "Bokningstyp raderad",
  RESERVATION_TYPE_UPDATED: "Bokningstyp uppdaterad",
  SERVICE_FEE_ADDED: "Serviceavgift tillagd",
  SERVICE_FEE_DELETED: "Serviceavgift raderad",
  SERVICE_FEE_UPDATED: "Serviceavgift uppdaterad",
  SHIFT_ADDED: "Skift tillagt",
  SHIFT_DELETED: "Skift raderat",
  SHIFT_UPDATED: "Skift uppdaterat",
  SMS_SENT: "SMS skickat",
  STRIPE_DISABLED: "Stripe inaktiverad",
  STRIPE_ENABLED: "Stripe aktiverad",
  SUBSTITUTION_ADDED: "Ersättning tillagd",
  SZAMLAZZ_DISABLED: "Szamlazz.hu inaktiverad",
  SZAMLAZZ_ENABLED: "Szamlazz.hu aktiverad",
  TODO_ADDED: "Att göra tillagd",
  TODO_DELETED: "Att göra raderad",
  TODO_UPDATED: "Att göra uppdaterad",
  TREATMENT_ADDED: "Behandling tillagd",
  TREATMENT_DELETED: "Behandling raderad",
  TREATMENT_UPDATED: "Behandling uppdaterad",
  VIDEO_CONSULTATION_STARTED: "Videokonsultation påbörjad",
};
